(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('mt-visible');
            }, Number(delay));
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var cifras = document.querySelectorAll('[data-mt-cifra]');
    if (!cifras.length) return;
    var animado = new WeakSet();
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !animado.has(entry.target)) {
            animado.add(entry.target);
            var el = entry.target;
            var fin = parseFloat(el.getAttribute('data-mt-cifra'));
            var sufijo = el.getAttribute('data-mt-sufijo') || '';
            var duracion = 1400;
            var inicio = null;
            function paso(ts) {
              if (!inicio) inicio = ts;
              var progreso = Math.min((ts - inicio) / duracion, 1);
              var facil = 1 - Math.pow(1 - progreso, 3);
              var valor = fin * facil;
              el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)) + sufijo;
              if (progreso < 1) requestAnimationFrame(paso);
            }
            requestAnimationFrame(paso);
          }
        });
      },
      { threshold: 0.4 }
    );
    cifras.forEach(function (el) { io.observe(el); });
  }

  function initResenasCarrusel() {
    var tracks = document.querySelectorAll('[data-mt-resenas-track]');
    tracks.forEach(function (track) {
      if (track.getAttribute('data-mt-init') === '1') return;
      track.setAttribute('data-mt-init', '1');
      var hijos = Array.prototype.slice.call(track.children);
      hijos.forEach(function (nodo) {
        track.appendChild(nodo.cloneNode(true));
      });
      var velocidad = Number(track.getAttribute('data-mt-velocidad')) || 40;
      var pos = 0;
      var ultimoTs = null;
      var mitad = 0;
      requestAnimationFrame(function medir() {
        mitad = track.scrollWidth / 2;
        if (mitad === 0) { requestAnimationFrame(medir); return; }
      });
      var pausado = false;
      track.addEventListener('mouseenter', function () { pausado = true; });
      track.addEventListener('mouseleave', function () { pausado = false; });
      function anim(ts) {
        if (!ultimoTs) ultimoTs = ts;
        var dt = (ts - ultimoTs) / 1000;
        ultimoTs = ts;
        if (!pausado && mitad > 0) {
          pos -= velocidad * dt;
          if (Math.abs(pos) >= mitad) pos = 0;
          track.style.transform = 'translateX(' + pos + 'px)';
        }
        requestAnimationFrame(anim);
      }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(anim);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCifras();
    initResenasCarrusel();
  });
})();
